import { render, staticRenderFns } from "./mov.vue?vue&type=template&id=260bba18&scoped=true"
var script = {}
import style0 from "./mov.vue?vue&type=style&index=0&id=260bba18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bba18",
  null
  
)

export default component.exports